<template>
  <div style="width:100%;padding-top: 60px">
	<div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
		<div style="text-align:center">
			<van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
		</div>
	</div>

<!--    <van-collapse>-->
<!--      <van-collapse-item title="减免明细" name="1" v-if="inputForm.category == 1">-->
<!--        <van-field label="项目名称" v-model="inputForm.projectName" input-align="left" :border="false" readonly autosize rows="1"-->
<!--                   type="textarea"></van-field>-->
<!--        <van-field label="客户名称" v-model="inputForm.customerName" input-align="left" :border="false" readonly></van-field>-->
<!--        <van-field v-if="inputForm.serviceType == 1" label="申请房号" v-model="inputForm.houseName" input-align="left" :border="false" readonly autosize rows="1"-->
<!--                   type="textarea"></van-field>-->
<!--        <van-field v-if="inputForm.serviceType == 2" label="合同编号" v-model="inputForm.code" input-align="left" :border="false" readonly autosize rows="1"-->
<!--                   type="textarea"></van-field>-->
<!--        <van-field label="减免总额(元)" v-model="inputForm.amount" input-align="left" :border="false" readonly></van-field>-->
<!--        <van-field label="发起人" v-model="inputForm.createByName" input-align="left" :border="false" readonly></van-field>-->
<!--        <van-field label="发起时间" v-model="inputForm.updateDate" input-align="left" :border="false" readonly></van-field>-->
<!--        <van-field label="减免说明" v-model="inputForm.remarks" input-align="left" :border="false" readonly autosize rows="1"-->
<!--                   type="textarea"></van-field>-->
<!--      </van-collapse-item>-->
<!--    </van-collapse>-->
      <div class="m-form" ref="scrollContainer" :style="'height:'+ layoutHeight+';overflow-y: auto;'" @scroll="handleScroll">
        <div class="title">减免明细</div>
        <div v-for="(data, index) in dataList" :key="index" style="margin-bottom: 10px">
          <div class="m-row" v-if="data.serviceType == 1">
            <div class="m-row-text">房号</div>
            <div class="m-row-content">{{ data.houseName }}</div>
          </div>
		  <div class="m-row">
		    <div class="m-row-text">客户名称</div>
		    <div class="m-row-content">{{ data.customerName }}</div>
		  </div>
		  <div class="m-row">
		    <div class="m-row-text">收费项目名称</div>
		    <div class="m-row-content">{{ data.feeItemName }}</div>
		  </div>
          <div class="m-row">
            <div class="m-row-text">计费区间</div>
            <div class="m-row-content">{{data.startDate}} 至 {{data.endDate}}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">应收金额(元)</div>
            <div class="m-row-content">{{data.amount.toFixed(2)}}</div>
          </div>
			<div class="m-row">
				<div class="m-row-text">已减免金额(元)</div>
				<div class="m-row-content">{{data.deratedAmount.toFixed(2)}}</div>
			</div>
			<div class="m-row">
				<div class="m-row-text">已收款金额(元)</div>
				<div class="m-row-content">{{data.paymentAmount.toFixed(2)}}</div>
			</div>
			<div class="m-row">
			  <div class="m-row-text">待收金额(元)</div>
			  <div class="m-row-content">{{(data.stayAmount).toFixed(2)}}</div>
			</div>
		<!-- <div class="m-row">
			<div class="m-row-text">已退款金额(元)</div>
			<div class="m-row-content">{{data.refundAmount.toFixed(2)}}</div>
		</div> -->
          <div class="m-row">
            <div class="m-row-text">本次减免金额(元)</div>
            <div class="m-row-content" style="color: red;">{{ data.dAmount.toFixed(2) }}</div>
          </div>
          <div class="m-row" style="border-bottom: 1px solid #eee">
            <div class="m-row-text">减免待收金额(元)</div>
            <div class="m-row-content">{{(data.stayAmount - data.dAmount).toFixed(2)}}</div>
          </div>
        </div>
      </div>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import DeratedApplyService from "../../api/finance/DeratedApplyService";
import processRecord from "../../components/processRecord/processRecord";

export default {
  data() {
    return {
      dataList: [],
      businessId: '',
      searchForm: {
        deratedId: ''
      },
	  tablePage: {
	    total: 0,
	    currentPage: 1,
	    pageSize: 5,
	    orders: []
	  },
	  layoutHeight: '0px',
	  time: 0
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
	this.$nextTick(() => {
		this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
		let query = this.$route.query;
		this.businessId = query.id
		this.init(this.businessId)
	});
  },
  methods: {
    init(id) {
      this.searchForm.deratedId = id
      this.refreshList()
    },
	handleScroll() {
	  const container = this.$refs.scrollContainer;
	  // 判断是否滚动到底部
	  
	  if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
		  // 滚动到底部，执行分页查询
		  if(new Date().getTime() - this.time >= 500){
			 this.tablePage.currentPage = this.tablePage.currentPage+1
			 this.refreshList(); 
			 this.time = new Date().getTime()
		  }
	  }
	},
    refreshList() {
      new DeratedApplyService().list({
	    'current': this.tablePage.currentPage,
	    'size': this.tablePage.pageSize,
	    'orders': this.tablePage.orders,
	    id: this.searchForm.deratedId
	  }).then(({data}) => {
		  if(this.tablePage.currentPage <= data.pages){
			  data.records.forEach(d=>{
				this.dataList.push(d)
			  })
		  }
      })
    },
	goBack(){
		this.$router.go(-2);
	}
  }
}
</script>

<style scoped>
	* {
	  margin: 0;
	  padding: 0;
	}
	.m-form {
	  width: 100vw;
	  padding: 10px;
	  font-size: 12px;
	  box-sizing: border-box;
	}
	.title {
	  width: calc(100vw - 20px);
	  height: 30px;
	  background-color: #eeeeee;
	  line-height: 30px;
	  font-weight: bold;
	  padding-left: 5px;
	  box-sizing: border-box;
	/*// margin-bottom: 20rpx;*/
	}

	.m-row {
	  display: flex;
	  width: calc(100vw - 22px);
	  border: 1px solid #eee;
	  border-bottom: 0px;
	}

	.m-row-text {
	  width: 110px;
	  padding-left: 5px;
	  border-right: 1px solid #eee;
	  /*border-bottom: 1px solid #eee;*/
	  display: flex;
	  align-items: center;
	  /*background-color: #eee;*/
	}

	.m-row-content {
	  width: calc(100vw - 130px);
	  height: 30px;
	  line-height: 30px;
	  padding-left: 10px;
	}

	.large-content {
	  width: calc(100vw - 130px);
	  min-height: 30px;
	  height: auto;
	  padding-left: 10px;
	  overflow: hidden;
	}
</style>
  